/*=========================================================================================
  File Name: module-licenseinfo-actions.js
  Description: LicenseInfo Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import RemoteSigningAPI from '@/api/RemoteSigningAPI.js';
import commonFunc from '@/common/commonFunction';
export default {
	// Lấy danh sách chứng thư số
	getListCertificate: async function (context, payload) {
		let res = await httpClient.getAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/listcertificate`,
				params: payload,
			},
			true
		);
		// Trả kết quả
		return res;
	},
	connectRemoteSigning: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/connect`,
				data: payload,
			},
			true
		);
		// Trả kết quả
		return res;
	},
	updateToView: async function (context, payload) {
		context.commit('updateToView', payload);
	},
	getCertRmDefault: async function (context, payload) {
		let res = await httpClient.getAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/getDefault`,
				params: payload,
			},
			true
		);
		// Trả kết quả
		return res;
	},
	getRemoteSigningInfo: async function (context, payload) {
		let res = await httpClient.getAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/getData`,
				params: payload,
			},
			true
		);
		if (res && res.Success) {
			res.Data.forEach((item) => {
				item.__vKeyValue = commonFunc.generateUUID();
			});
			context.commit('setCertsConnect', res.Data);
		}
		// Trả kết quả
		return res;
	},
	removeConnect: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/removeconnect`,
				data: payload,
			},
			true
		);
		// Trả kết quả
		return res;
	},
	disabledConnect: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/disabled`,
				data: payload,
			},
			false
		);
		// Trả kết quả
		return res;
	},
	removeConnectValue: async function (context, payload) {
		context.commit('removeConnectValue', payload);
	},
	signingRm: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/signing`,
				data: payload,
			},
			false,
			false
		);
		// Trả kết quả
		return res;
	},
	updateLstConnectDefault: async function (context, payload) {
		let res = await httpClient.postAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/default`,
				data: payload,
			},
			true
		);
		if (res && res.Success) {
			context.commit('updateLstConnectDefault', payload);
		}
		return res;
	},
	// Lấy ra link direct sang misa store
	directToRemoteSigning: async function (context, payload) {
		return await httpClient.getAsync(
			{
				url:
					RemoteSigningAPI.getAPIUrl() +
					`/direct/${payload.MisaId}/${payload.TaxCode}`,
			},
			true
		);
	},
	// Kiểm tra trạng thái ký số từ xa (chế độ async)
	checkSigningStatus: async function (context, payload) {
		return await httpClient.getAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/signing-status`,
				params: {
					taxCode: payload.taxCode,
					transactionId: payload.transactionId,
				},
			},
			false
		);
	},
	// Lấy file đã ký từ cache (chế độ async)
	getSignedFile: async function (context, payload) {
		return await httpClient.getAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + `/signed-file`,
				params: {
					taxCode: payload.taxCode,
					transactionId: payload.transactionId,
				},
			},
			false
		);
	},
	getCompensCertStatusAsync: async function (context) {
		context.commit('setCompensCertLoading', true);
		try {
			const res = await httpClient.getAsync(
				{ url: RemoteSigningAPI.getAPIUrl() + '/compenscert' },
				false
			);
			if (res && res.Success)
				context.commit('setCompensCertList', res.Data);
			return res;
		} finally {
			context.commit('setCompensCertLoading', false);
		}
	},
	// Lấy bước đã hoàn thành của quy trình cấp bù CTS theo user và MST đang làm việc
	getCompensCertStepAsync: async function (context) {
		const res = await httpClient.getAsync(
			{ url: RemoteSigningAPI.getAPIUrl() + '/compenscert-step' },
			false
		);
		if (res && res.Success) {
			context.commit('setCompensCertData', res.Data);
			if (res.Data && res.Data.CompensCertStep !== undefined) {
				context.commit('setCompensCertStep', res.Data.CompensCertStep);
			}
			if (res.Data && res.Data.CompensCertLastShownDate !== undefined) {
				context.commit(
					'setCompensCertLastShownDate',
					res.Data.CompensCertLastShownDate
				);
			}
		}
		return res;
	},
	// Ghi nhận trạng thái cấp bù CTS — backend chỉ tiến bước, không lùi
	// payload: số bước (chỉ cập nhật bước) hoặc object { CompensCertStep, IsDecSuccess, IsPaySuccess }
	updateCompensCertStepAsync: async function (context, payload) {
		const res = await httpClient.postAsync(
			{
				url: RemoteSigningAPI.getAPIUrl() + '/update-compenscert-step',
				data: payload,
			},
			false
		);
		if (res && res.Success) {
			const state = context.state;
			const step = Math.max(
				payload.CompensCertStep,
				state.compensCertData
					? state.compensCertData.CompensCertStep
					: 0
			);
			context.commit('setCompensCertData', {
				...state.compensCertData,
				...payload,
				CompensCertStep: step,
			});
			context.commit('setCompensCertStep', step);
		}
		return res;
	},

	updateCompensCertLastShowAsync: async function (context) {
		const res = await httpClient.postAsync(
			{
				url:
					RemoteSigningAPI.getAPIUrl() +
					'/update-compenscert-last-show',
			},
			false
		);
		if (res && res.Success) {
			return res.Data;
		}
		return false;
	},
};
